import { Form, Modal } from "antd";
import React from "react";
import { CreateReportPekDto } from "../../../api";
import { ReportPeksColumns } from "../form/columns";

interface ReportPeksFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateReportPek: (values: CreateReportPekDto) => void;
  organizationId?: string;
}

export const ReportPekForm: React.FC<ReportPeksFormProps> = ({ visible, setVisible, onCreateReportPek, organizationId }) => {
  const [form] = Form.useForm<CreateReportPekDto>();

  const onChange = (value: any, additional?: any) => {

    (Object.keys(form.getFieldsValue()) as (keyof CreateReportPekDto)[]).find((key) => {
      return form.getFieldsValue()[key] === value;
    });

  }

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateReportPek}>
        {ReportPeksColumns().map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {
              React.cloneElement(
                inputNode,
                {
                  onChange: onChange
                }
              )
            }
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
